export enum FunnelRoute {
  business = 'business',
  communityHousingPartners = 'community-housing-partners',
  communitySolar = 'community-solar',
  conference = 'conference',
  goSolar = 'go-solar',
  isolarUcb = 'isolar-ucb',
  membership = 'membership',
  solarLandscape = 'solar-landscape',
  // To be fixed in a future PR to fix telesales
  telesales = 'community-solar',
  telesalesNoPayment = 'community-solar',
  constellation = 'constellation',
  perchEnergy = 'perch-energy',
}
